export const httpParams = {
  card: "card-pay",
  pix: "pay",
  boleto: "pay",
  fixcoin: "fixcoin-pay",
};
